<template>
  <div class="relative">
    <basic-input
      v-bind="$attrs"
      @focus="isFocused = true"
      ref="input"
      rules="required"
      @blur="blured()"
      @input="search = $event"
      :value="computedValue"
      autocomplete="off"
    >
      <div
        v-if="isFocused"
        class="absolute w-full bg-white border z-10 rounded-b max-h-56 overflow-y-auto"
      >
        <ul>
          <li
            v-for="item in filteredGenres"
            @mousedown.prevent
            :key="item.value"
            @click="emit(item.value)"
            class="py-2 px-4 hover:bg-gray-100 cursor-pointer text-sm"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>

      <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
        <button v-if="computedValue" @click="emit(null)">
          <font-awesome-icon :icon="['far', 'times']" class="text-gray-600" />
        </button>
      </div>
    </basic-input>
  </div>
</template>


<script>
import _find from 'lodash/find';
import BasicInput from '@/components/basic/Input';

export default {
  components: { BasicInput },
  props: ['value'],
  data() {
    return {
      isFocused: false,
      search: '',
      genres: [
        { value: 28482, label: 'Ausstellung' },
        { value: 28471, label: 'Comedy' },
        { value: 28479, label: 'Entertainment' },
        { value: 28472, label: 'Familie' },
        { value: 28485, label: 'Festival' },
        { value: 28483, label: 'Film' },
        { value: 28470, label: 'Kabarett' },
        { value: 28468, label: 'Konzerte' },
        { value: 28480, label: 'Lesungen' },
        { value: 28481, label: 'Livestream' },
        { value: 28475, label: 'Messen und Kongresse' },
        { value: 28473, label: 'Musical' },
        { value: 28484, label: 'Performance' },
        { value: 28477, label: 'Poetry' },
        { value: 28476, label: 'Sport' },
        { value: 28478, label: 'Tanz' },
        { value: 28469, label: 'Theater' },
        { value: 28474, label: 'Workshops' },
        { value: 28486, label: 'Sonstige' },
      ],
    };
  },
  computed: {
    filteredGenres() {
      return this.genres.filter((genre) => {
        return genre.label.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    computedValue() {
      if (this.isFocused) {
        return this.search;
      } else {
        let found = _find(this.genres, (genre) => {
          return genre.value === this.value;
        });

        return found ? found.label : '';
      }
    },
  },
  methods: {
    blured() {
      this.isFocused = false;
      this.search = '';
    },
    emit(value) {
      this.$emit('input', value);
      this.blured();
      this.$refs.input.$refs.input.blur();
    },
  },
};
</script>